// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__carts',
    // #endregion
});
// #endregion
